export default "__VITE_ASSET__DKcKhp$u__"